import AssetFacts from "./components/asset-facts";
import AssetTabs from "./components/asset-tabs";

import BarbaJs from "./features/barba-js";
new BarbaJs();

document.documentElement.classList.replace('no-js', 'js');
